import './list.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table';
import AffiliateDistributionPopup from './components/affiliate-distribution-popup';
import CloneAdminPopup from './components/clone-admin-popup';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content admins-list">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('List of admins')}</h1>
				</div>
			</div>
			<div className="container__content-body">
				<div className="admins-list__create">
					{ props.can('create') && (
						<Link
							to="admins/create/"
							className="ui-btn ui-btn-primary ui-btn-sign__plus">{props.intl('Create new admin')}</Link>
					) }
					{ props.can('create') && (
						<button className="ui-btn ui-btn-primary clone-button" onClick={props.toggleCloneAdminPopup}>
							{props.intl('Create as clone')}
						</button>
					) }
					{ props.can('create') && (
						<button className="ui-btn ui-btn-primary clone-button" onClick={props.toggleAffiliateDistributionPopup}>
							{props.intl('Distribute affiliates')}
						</button>
					) }
				</div>
				<Table {...props} />
				<AffiliateDistributionPopup {...props}/>
				<CloneAdminPopup {...props}/>
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		showAffiliatedDistributionPopup: selectors.getShowAffiliatedDistributionPopup(state),
		isClonePopupVisible: selectors.getIsClonePopupVisible(state),
		admins: selectors.getAdmins(state),
		managers: selectors.getManagers(state),
		adminToRemove: selectors.getAdminToRemove(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/list.js